// src/pages/billing/CancelPage.jsx
// Cancel page when user cancels Stripe checkout

import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button, Stack } from "@mui/material";
import SentimentDissatisfiedRoundedIcon from "@mui/icons-material/SentimentDissatisfiedRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";

export default function CancelPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f5f7fa",
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 5,
          maxWidth: 500,
          width: "100%",
          textAlign: "center",
          borderRadius: 3,
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            width: 100,
            height: 100,
            borderRadius: "50%",
            bgcolor: "grey.200",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 3,
          }}
        >
          <SentimentDissatisfiedRoundedIcon
            sx={{ fontSize: 60, color: "grey.500" }}
          />
        </Box>

        <Typography variant="h4" fontWeight={800} gutterBottom>
          Checkout Cancelled
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          No worries! Your checkout was cancelled and you haven't been charged.
          You can try again whenever you're ready.
        </Typography>

        <Stack spacing={2}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/pricing")}
            sx={{
              py: 1.5,
              fontWeight: 700,
              borderRadius: 2,
            }}
          >
            Try Again
          </Button>

          <Button
            variant="outlined"
            startIcon={<ArrowBackRoundedIcon />}
            onClick={() => navigate("/app")}
            sx={{
              py: 1.5,
              borderRadius: 2,
            }}
          >
            Back to Home
          </Button>
        </Stack>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 4 }}
        >
          Questions? Contact us at support@agentblayna.com
        </Typography>
      </Paper>
    </Box>
  );
}
